<template>

  <header class="main-header w-100 z-999">
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark" style="height: 60px;">
      <div class="container d-flex align-items-center justify-content-lg-between position-relative">

        <a class="navbar-brand fw-bold" href="/">
          <img src="/images/logo.png" alt="" height="32" class="d-inline-block align-text-top"/>
        </a>

        <div class="d-flex flex-grow-1">

          <ul class="navbar-nav justify-content-start d-none d-lg-flex flex-grow-1 align-items-center" >

            <!--     Блок со ссылками для главной       -->
              <li class="nav-item" v-for="item in menu" :key="item.label">
                <a class="nav-link" :href="item.href" v-if="item?.href">{{ item.label }}</a>
                <router-link
                    class="nav-link"
                    :class="{ 'active disabled': router.currentRoute.value.path === item.path }"
                    :to="item.path"
                    v-if="item?.path"
                >{{ item.label }}</router-link>
              </li>
            <!--     /Блок со ссылками для главной       -->
          </ul>

          <ul class="navbar-nav d-flex flex-row ms-lg-0 ms-auto">

            <template v-if="user">
              <li class="nav-item">
                  <span role="button" class="text-white navbar-icon" @click="router.push('/user/movies')"
                        title="Профиль">
                    <i class="bi bi-person-circle"></i>
                  </span>
              </li>
            </template>
            <li class="nav-item" v-else>
              <router-link to="/login" class="btn btn-primary">Войти в аккаунт</router-link>
            </li>
          </ul>

        </div>


      </div>
    </nav>
  </header>

</template>

<script setup>
import {computed, ref} from "vue";
import { useStore } from "@/store/store";
const store = useStore();

import router from "@/router/router";

const user = computed(() => store.getP('user'))
const baseUrl = window.location.origin;
const currUrl = router.currentRoute.value.path

const menu = computed( () => {
  if(router.currentRoute.value.path.startsWith("/user")) {
    return [
      { label: "Фильмы", path: '/user/movies' },
      { label: "Комментарии", path: '/user/comments' },
      { label: "Лендинги", path: '/user/landing/list' },
      { label: "Домены", path: '/user/domains/list' },
    ]
  }
  else {
    return [
      { label: "Главная", path: '/' },
      { label: "Фильмы", path: '/movies/all' },
      { label: "Сериалы", path: '/movies/serial' },
      { label: "Спорт", path: '/movies/sport' },
    ]
  }

})

</script>

<style scoped>
.shimmer-badge {
  background: linear-gradient(45deg, #ff4d4d, #ff0000, #ff4d4d);
  background-size: 200% 200%;
  color: white;
  font-size: 0.75rem;
  padding: 0.25em 0.5em;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
  top: 12px;
}


</style>